import { useState } from 'react';

export default function useImageModal() {
  const [imageSrc, setImageSrc] = useState(null);

  const openModal = (src) => setImageSrc(src);
  const closeModal = () => setImageSrc(null);

  const modal = imageSrc && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 999999,   // <-- SUPER HIGH 🔥
      pointerEvents: 'auto'
    }}
    onClick={closeModal}
  >
      <button
        style={{
          position: 'absolute',
          top: '20px',
          right: '30px',
          fontSize: '2rem',
          color: '#fff',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
        }}
        onClick={(e) => {
          e.stopPropagation();
          closeModal();
        }}
      >
        &times;
      </button>

      <img
        src={imageSrc}
        alt=""
        style={{
          maxWidth: '90%',
          maxHeight: '90%',
          borderRadius: '12px',
          boxShadow: '0 0 15px rgba(0,0,0,0.4)',
        }}
      />
    </div>
  );

  return { openModal, closeModal, modal };
}